<template>
  <div>
    <header class="l-header__inner header js-header" :class="{ header_contact: isContact }">
      <div class="menu">
        <a href="./" class="logo"><img src="../assets/img/smart_mirror_logo.svg" alt="スマートミラーロゴ"></a>
        <div
          class="menu-trigger"
          :class="{ active: isMenuOpened }"
          v-show="isMenuBarActive"
          href="#"
          @click="switchMenu"
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <transition name="nav_slide" v-on:after-leave="afterLeave">
        <nav v-show="isMenuOpened" v-bind:class="{ nav_menu: isMenuBarActive }">
          <ul class="header_nav">
            <li><a @click="switchMenu" href="/#product">Product</a></li>
            <li><a @click="switchMenu" href="/#case">Use Case</a></li>
            <li><a @click="switchMenu" href="/#faq">FAQ</a></li>
            <li class="contact_btn">
              <a @click="switchMenu" href="/#contact">CONTACT</a
              >
            </li>
          </ul>
        </nav>
      </transition>
    </header>
    <!--ドロワー背景-->
    <div class="overlay" v-show="isOverlayActive" @click="closeMenu"></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isPageTopActive: false,
      isMenuBarActive: true,
      isMenuOpened: false,
      isOverlayActive: false,
      isContact: false,
      scroll: 0,
      width: window.innerWidth
    }
  },
  mounted () {
    window.addEventListener("scroll", this.scrollWindow)
    window.addEventListener("resize", this.handleResize)
    this.handleResize()
    if (this.$route.path === '/download' || this.$route.path === '/contact') {
      this.isContact = true
    }
  },
  methods: {
    to (to) {
      var nav = document.getElementById("nav-input")
      nav.checked = false
      location.hash = to
    },
    switchMenu () {
      this.width = window.innerWidth
      if (this.width <= 821) {
        this.isMenuOpened = !this.isMenuOpened
        this.isOverlayActive = true
      }
    },
    closeMenu () {
      this.isMenuOpened = false
      this.isOverlayActive = false
    },
    afterLeave () {
      this.isOverlayActive = false
    },
    returnTop () {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      })
    },
    scrollWindow () {
      const top = 100 // ボタンを表示させたい位置
      this.scroll = window.scrollY
      if (top <= this.scroll) {
        this.isPageTopActive = true
      } else {
        this.isPageTopActive = false
      }
    },
    handleResize () {
      this.width = window.innerWidth
      if (this.width > 821) {
        this.isMenuBarActive = false
        this.isMenuOpened = true
      } else {
        this.isMenuBarActive = true
        this.isMenuOpened = false
      }
    }
  }
}
</script>

<style scoped>
header {
  position: relative;
}
.header_contact {
  background-color: white;
}
.logo img {
  height: 26px;
}
.l-header__inner {
  height: 70px;
  display: flex;
  align-items: center;
  position: fixed;
  justify-content: space-between;
  width: 100%;
  z-index: 10;
  padding-left: 75px;
}
.header_nav {
  display: flex;
  text-transform: uppercase;
  height: 70px;
  align-items: center;
}
.header_nav li {
  padding: 0px 20px;
  font-family: neue-haas-grotesk-display, sans-serif;
  font-weight: 600;
  font-style: normal;
  letter-spacing: 4px;
  font-size: 16px;
}
.header_nav li:nth-child(-n + 4) {
  padding: 0px 20px;
}
.header_nav li:last-child {
  background-color: #000000;
  height: inherit;
  display: flex;
  align-items: center;
  color: #ffffff;
}
.header_nav li:last-child:hover {
  background-color: #0071e3;
  color: #ffffff;
}
.header_nav a:hover {
  color: #0071e3;
}
.header.headerColorScroll {
  background-color: #ffffff;
  transition: color 0.4s ease-out;
}
.contact_btn a:hover {
  color: #ffffff !important;
}
.contact_btn a {
  height: 100%;
  padding: 0px 40px;
  display: flex;
  align-items: center;
}

/*---- header グローバルナビ背景----*/
.overlay::after {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 3;
}

@media screen and (max-width: 821px) {
  .l-header__inner {
    flex-direction: column;
    padding: 20px;
    height: auto;
  }
  .menu-trigger,
  .menu-trigger span {
    display: inline-block;
    transition: all 0.4s;
    box-sizing: border-box;
  }
  .menu-trigger {
    display: flex;
    position: relative;
    z-index: 2;
    margin: 0px;
    width: 50px;
    height: 30px;
    border-radius: 50px;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
  }
  .menu-trigger span {
    left: 10px;
    width: 30px;
    height: 2px;
    background-color: #333333;
    border-radius: 4px;
  }
  .menu-trigger.active span:nth-of-type(1) {
    transform: translateY(11px) rotate(-45deg);
    background-color: #333333;
  }
  .menu-trigger.active span:nth-of-type(2) {
    transform: translateY(-4px) rotate(45deg);
    background-color: #333333;
  }
  .menu-trigger.active span:nth-of-type(3) {
    display: none;
  }
  nav {
    width: 100%;
    background-color: #ffffff;
    position: absolute;
    top: 0px;
    right: 0px;
    z-index: 1;
    overflow: auto;
    height: auto;
    box-sizing: border-box;
  }
  .menu {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
  }
  .nav_menu {
    height: 430px;
    overflow: hidden;
  }

  .header_nav {
    flex-wrap: wrap;
    height: auto;
    text-align: center;
    padding: 40px 25px 50px;
  }
  .header_nav li {
    width: 100%;
    padding: 0;
  }
  .header_nav li:last-child {
    padding: 0;
  }
  .header_nav li:first-of-type {
    margin-top: 30px;
  }
  .header_nav li:nth-child(3) {
    margin-bottom: 30px;
  }
  .header_nav a {
    padding: 26px;
    display: block;
    width: 100%;
    box-sizing: border-box;
  }
  .contact_btn a {
    padding: 30px 10px;
    box-sizing: border-box;
  }
  .logo {
    z-index: 2;
  }
}
.nav_slide-enter-active,
.nav_slide-leave-active {
  transition: all 0.4s;
}
.nav_slide-enter,
.nav_slide-leave-to {
  height: 0;
}
</style>
